"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SESSION_INACTIVITY_LOGGED_OUT_EVENT = void 0;
var _react = require("react");
var _addinSessionLifetime = require("@common/utils/addin-session-lifetime");
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _AuthContext = require("../../context/AuthContext");
var _addinAuth = require("../../utils/addin-auth");
var _addinLogout = require("../../utils/addin-logout");
var SESSION_INACTIVITY_LOGGED_OUT_EVENT = exports.SESSION_INACTIVITY_LOGGED_OUT_EVENT = "session_inactivity_logged_out";
var KEY_EXPIRY_CHECK_INTERVAL_MS = 1000;
function SessionExpiryLogout() {
  var _orgHelper$getOrg;
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    orgHelper = _useAuthInfo.orgHelper;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    analytics = _useAnalytics.analytics;
  var orgId = orgHelper === null || orgHelper === void 0 ? void 0 : orgHelper.getOrgIds()[0];
  var orgMetadata = orgId ? orgHelper === null || orgHelper === void 0 || (_orgHelper$getOrg = orgHelper.getOrg(orgId)) === null || _orgHelper$getOrg === void 0 ? void 0 : _orgHelper$getOrg.orgMetadata : null;
  var sessionLifetimeSeconds = (0, _addinSessionLifetime.addinSessionLifetimeSeconds)(orgMetadata);
  (0, _react.useEffect)(function () {
    var expiryCheck = setInterval(function () {
      if (!(0, _addinAuth.isApiKeyExpiredLocally)()) return;
      clearInterval(expiryCheck);
      analytics === null || analytics === void 0 || analytics.track(SESSION_INACTIVITY_LOGGED_OUT_EVENT, {
        sessionLifetimeSeconds: sessionLifetimeSeconds
      });
      void (0, _addinLogout.logOutOfAddin)(null);
    }, KEY_EXPIRY_CHECK_INTERVAL_MS);
    return function () {
      return clearInterval(expiryCheck);
    };
  }, [analytics, sessionLifetimeSeconds]);
  return null;
}
var _default = exports.default = SessionExpiryLogout;